module.exports = __webpack_public_path__ + "img/social-proof-v2.ff0683e2.png";